export default "__VITE_ASSET__$8WJ$6jG__"